import React, { useState } from "react";
import "./Navbar.css";
import MenuIcon from "@material-ui/icons/Menu";
import ClearIcon from "@material-ui/icons/Clear";
import { NavLink, Link } from "react-router-dom";
function Navbar() {
	const [click, setClick] = useState(false);
	const [button, setButton] = useState(true);
	//hnadle the mobile menu
	const closeMobileMenu = () => setClick(false);
	const handleClick = () => setClick(!click);
	const showButton = () => {
		if (window.innerWidth <= 960) {
			setButton(false);
		} else {
			setButton(true);
		}
	};

	window.addEventListener("resize", showButton);
	return (
		<div className="navbar">
			<div className="navbar___Container container">
				<Link to="/" className="navbar__logo">
					iamndeleva
				</Link>
				<div className="menu__icon" onClick={handleClick}>
					{click ? <ClearIcon /> : <MenuIcon />}
				</div>
				<ul className={click ? "nav__menu active" : "nav__menu"}>
					<li className="nav__item">
						<Link to="/" className="nav__links">
							Home
						</Link>
					</li>
					<li className="nav__item">
						<Link to="/about" className="nav__links">
							About
						</Link>
					</li>
					<li className="nav__item">
						<Link to="/portfolio" className="nav__links">
							Projects
						</Link>
					</li>
					<li className="nav__item">
						<Link to="/contact" className="nav__links">
							Contact
						</Link>
					</li>
					<li className="nav__item">
						<Link to="/blog" className="nav__links">
							Blog
						</Link>
					</li>
				</ul>
			</div>
		</div>
	);
}

export default Navbar;
